import { productPreviewHtmlLight } from '../productPreviewHtml';

// We use `srcDoc` (not `src`) so the preview is rendered entirely from the
// JS bundle. This avoids any dependency on the static `/product-preview.html`
// being served correctly in production and bypasses any `X-Frame-Options`
// header that an edge proxy / CDN might add to host responses.
const AuthShowcasePanel = ({ isRegister = false }) => {
  return (
    <aside className="auth-showcase" aria-label="Product preview">
      <div className="auth-showcase-frame-wrap">
        <iframe
          title="Founders+ app preview"
          srcDoc={productPreviewHtmlLight}
          className="auth-showcase-frame"
          sandbox="allow-scripts"
          loading="eager"
        />
      </div>
    </aside>
  );
};

export default AuthShowcasePanel;
